// TODO: перенести сюда директиву, избавившись от зависимости "v-click-outside" в package.json
import vClickOutside from 'v-click-outside'

export default vClickOutside.directive